import { Box, Button, Grid, MultiSelect, Text, TextInput, Title } from '@mantine/core'
import { useForm } from '@mantine/form';
import { deleteOpinion, updateOpinion } from 'api/fetch/opinion';
import { useQueryCategory } from 'api/hook/category';
import { Category, Opinion } from 'api/types';
import { useEffect, useState } from 'react';
import { parseErrorMsg } from 'utils';
import { modals } from '@mantine/modals';


export default function OpinionEdit({
    opinion,
    onUpdate,
}: {
    opinion: Opinion
    onUpdate?: () => void
}) {

    const form = useForm({
        initialValues: {
            title_krd: opinion?.title_krd || '',
            title_en: opinion?.title_en || '',
            title_ar: opinion?.title_ar || '',
            categories: opinion?.categories ? opinion.categories.map((category: Category) => String(category.id)) : [],
        },
    });

    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const [search, setSearch] = useState('');

    const categoryQuery = useQueryCategory({
        offset: 0,
        limit: 100,
        search,
        // include: opinion?.categories ? opinion.categories.map((category: Category) => category.id) : [],
    });


    return (
        <Box>
            <Box
                p={'md'}
                sx={theme => ({
                    maxWidth: 600,
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
                })}
            >
                <form onSubmit={form.onSubmit((values) => {
                    setLoading(true);
                    updateOpinion({
                        id: opinion.id,
                        ...values,
                        ...(values.categories ? {
                            categories: values.categories.map((category: string) => Number(category)),
                        } : {
                            categories: [],
                        }),
                    }).then(() => {
                        onUpdate && onUpdate();
                    }).catch((error) => {
                        alert(parseErrorMsg(error));
                    }).finally(() => {
                        setLoading(false);
                    });
                })}>
                    <Grid>
                        <Grid.Col span={12}>
                            <Title>
                                Title
                            </Title>
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <TextInput
                                radius={0}
                                label="Title in Arabic"
                                dir='rtl'
                                sx={{
                                    '& input': {
                                        textAlign: 'right',
                                    }
                                }}
                                {...form.getInputProps('title_ar')}
                            />
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <TextInput
                                radius={0}
                                dir='rtl'
                                sx={{
                                    '& input': {
                                        textAlign: 'right',
                                    }
                                }}
                                label="Title in Kurdish"
                                {...form.getInputProps('title_krd')}
                            />
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <TextInput
                                radius={0}
                                label="Title in English"
                                {...form.getInputProps('title_en')}
                            />
                        </Grid.Col>

                        <Grid.Col span={12}>
                            <Title>
                                Categories
                            </Title>
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <MultiSelect
                                data={[
                                    ...(categoryQuery.data?.categories || []),
                                    ...(opinion?.categories || []),
                                ].map((category: Category) => {
                                    return {
                                        value: String(category.id),
                                        label: `${category.name_ar} - ${category.name_krd} - ${category.name_en} (${category.count})`,
                                    };
                                })}
                                placeholder="Select category"
                                radius={0}
                                searchable
                                nothingFound="No category found"
                                onSearchChange={setSearch}
                                {...form.getInputProps('categories')}
                            />
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <Button
                                type="submit"
                                radius={0}
                                fullWidth
                                loading={loading}
                                disabled={deleteLoading}
                            >
                                Save
                            </Button>
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <Button
                                radius={0}
                                fullWidth
                                loading={deleteLoading}
                                disabled={loading}
                                color="red"
                                variant="outline"
                                onClick={() => {
                                    // show confirmation modal
                                    setDeleteLoading(true);
                                    modals.openConfirmModal({
                                        title: 'Please confirm deletion',
                                        children: (
                                            <Text size="sm">
                                                You will not be able to recover this opinion! please confirm deletion or cancel action.
                                            </Text>
                                        ),
                                        labels: { confirm: 'Delete', cancel: 'Cancel' },
                                        onCancel: () => {
                                            setDeleteLoading(false);
                                        },
                                        onConfirm: () => {
                                            deleteOpinion({
                                                id: opinion.id,
                                            }).then(() => {
                                                onUpdate && onUpdate();
                                            }).catch((error) => {
                                                alert(parseErrorMsg(error));
                                            }).finally(() => {
                                                setDeleteLoading(false);
                                            });
                                        },
                                    });

                                }}
                            >
                                Delete
                            </Button>
                        </Grid.Col>
                    </Grid>
                </form>
            </Box>
        </Box>
    );

}